import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectCompanyComponent } from './select-company.component';

@NgModule({
  declarations: [
    SelectCompanyComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    SelectCompanyComponent,
  ],
  providers: []
})
export class SelectCompanyModule { }


